import { Snackbar, Alert } from "@mui/material";
import "./styles.css";
import PropTypes from "prop-types";
import React from "react";

SnackbarAlert.propTypes = {
  showSnackBarAlert: PropTypes.object,
  handleSnackbarClose: PropTypes.func,
};
export default function SnackbarAlert({
  showSnackBarAlert,
  handleSnackbarClose,
}: {
  showSnackBarAlert: any;
  handleSnackbarClose: any;
}) {
  const vertical = "top";
  const horizontal = "right";

  return (
    <>
      {showSnackBarAlert?.type ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          key={vertical + horizontal}
          open={showSnackBarAlert.status}
          autoHideDuration={3000}
          onClose={(event, reason) => {
            if (reason === "clickaway") return;
            handleSnackbarClose();
          }}
          sx={{ top: "64px !important" }}
        >
          <Alert
            variant="filled"
            onClose={handleSnackbarClose}
            severity={showSnackBarAlert.type}
            sx={{ whiteSpace: "pre-wrap", borderRadius: 0 }}
            className="alert"
          >
            {showSnackBarAlert.message}
          </Alert>
        </Snackbar>
      ) : null}
    </>
  );
}
